import { SequenceConfigScope } from "@swivl-mono/api-helper";
import { BotSequenceConfigFieldSource, LocationPageInterface, LocationScope } from "@swivl-mono/types";

export type SequenceScopeKind = "org" | "group" | "location";

export interface SequencePageScope {
  kind: SequenceScopeKind;
  /** The API scope: location scope passes ONLY locationId (the server rejects both). */
  api: SequenceConfigScope;
  groupId: number | null;
  locationId: number | null;
}

/** The Property Manager URL → the scope the config API is addressed with. */
export function sequenceScopeForPage(page: LocationPageInterface, orgId: number): SequencePageScope {
  if (page.type === LocationScope.LOCATION && page.locationId) {
    return { kind: "location", api: { orgId, locationId: page.locationId }, groupId: page.groupId ?? null, locationId: page.locationId };
  }
  if (page.type === LocationScope.GROUP && page.groupId) {
    return { kind: "group", api: { orgId, groupId: page.groupId }, groupId: page.groupId, locationId: null };
  }
  return { kind: "org", api: { orgId }, groupId: null, locationId: null };
}

/** True when the effective value comes from THIS scope (own row) rather than one above or the platform default. */
export function isOwnSource(source: BotSequenceConfigFieldSource, scope: SequenceScopeKind): boolean {
  return source === scope;
}

export function scopeNoun(scope: SequenceScopeKind): string {
  return scope === "org" ? "organization" : scope;
}
